<template>
  <div class="icon-box">
    <img :src="image_src" class="icon"/>
  </div>
</template>

<script>
export default {
  name: 'icon-box',
  props: {
    src: {type: String}
  },
  computed: {
    image_src () {
      return require('@/assets/images/icons/' + this.src + '.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.icon-box {
  @include flex(flex,center,center,row,nowrap);
  .icon {
    height: auto;
  }
  &.-w20 {
    .icon {
      width: 20px;
    }
  }
  &.-w30 {
    .icon {
      width: 30px;
    }
  }
  &.-w40 {
    .icon {
      width: 40px;
      max-height: 40px;
    }
  }
  &.-xs {
    .icon {
      width: 14px;
      max-height: 14px;
      @include mq-up(){
        width: 16px;
        max-height: 16px;
      }
    }
  }
  &.-sm {
    .icon {
      width: 20px;
      max-height: 20px;
      @include mq-up(){
        width: 30px;
        max-height: 30px;
      }
    }
  }
  &.-md {
    .icon {
      width: 30px;
      max-height: 30px;
      @include mq-up(){
        width: 40px;
        max-height: 40px;
      }
    }
  }
  &.-lg {
    .icon {
      width: 30px;
      max-height: 30px;
      @include mq-up(){
        width: 40px;
        max-height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/icon-box.vue